// THIS IS BEING PHASED OUT IN FAVOR OF Header.js
import React from 'react';
import { colors } from 'helpers/ColorHelper';

const rootStyle = {
  backgroundColor: colors.LIGHT_GRAY,
  padding: '5px 10px',
  fontSize: '14px',
  fontWeight: '800',
};

export default ({ name, style }) => (
  <div className="row" style={{ ...rootStyle, ...(style || {}) }}>
    <div className="col-xs-12">
      <p style={{ margin: '0', textAlign: 'center' }}> {name} </p>
    </div>
  </div>
);
